<template>
  <div class="index-page">
    <div class="index-search">
      <div class="classify" @click="setClassify">
        <span>{{ classify_name }}</span>
        <img src="@/assets/images/icon_classify@2x.png" />
      </div>
      <router-link class="search" :to="{ name: 'Search' }">
        <img src="@/assets/images/search.png" />
        <span style="border: undefined solid red">请输入课程名称</span>
      </router-link>
      <span class="message" @click="$router.push({ name: 'Message' })">
        <i v-if="messageCount">{{ messageCount }}</i>
      </span>
    </div>
    <div class="index-banner" v-if="bannerList && bannerList.length > 0">
      <div class="banner">
        <van-swipe :autoplay="5000" indicator-color="white">
          <van-swipe-item
            v-for="(item, index) in bannerList"
            :key="index"
            @click="bannerClick(item)"
          >
            <img
              :src="
                item.banner_img
                  ? item.banner_img
                  : '../assets/images/place_image.png'
              "
            />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="index-kinds">
      <ul>
        <li
          v-for="(item, index) in kind_list"
          :key="index"
          @click="goFunction(item.path)"
        >
          <img :src="item.imgSrc" />
          <font>{{ item.label }}</font>
        </li>
      </ul>
    </div>
    <section
      v-for="(item, index) in recommend"
      :key="index"
      style="margin-bottom: 4vw"
    >
      <p class="op-title">
        {{ item.channel_info.name }}
        <span class="more" @click="toMore(item)"
          >查看更多 <van-icon style="margin-top: -0.93333vw" name="arrow"
        /></span>
      </p>
      <!-- 课程 -->
      <index-item
        :course="item.list"
        v-if="item.channel_info.type == 1 || item.channel_info.type == 2"
      ></index-item>
      <!-- 讲师、图书、资讯、章节练习、模拟考试的推荐 -->
      <recommend-item
        v-else
        :type="item.channel_info.type"
        :list="item.list"
      ></recommend-item>
    </section>
  </div>
</template>
<script>
import store from "../../store";
import { mapState } from "vuex";
import indexItem from "@/components/CourseItem";
import recommendItem from "@/components/RecommendItem";

export default {
  name: "Index",
  components: {
    indexItem,
    recommendItem,
  },
  computed: mapState(["classify_name"]),
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 10,
        initialSlide: 0,
      },
      bannerList: [],
      recommend: [],
      kind_list: [
        {
          label: "图书",
          imgSrc: require("@/assets/images/index/index-kinds-book.png"),
          path: "BookList",
        },
        {
          label: "资讯",
          imgSrc: require("@/assets/images/index/index-kinds-news.png"),
          path: "News",
        },
        {
          label: "签到领积分",
          imgSrc: require("@/assets/images/index/index-kinds-signIn.png"),
          path: "Sign",
        },
        {
          label: "学习日历",
          imgSrc: require("@/assets/images/index/index-kinds-canledar.png"),
          path: "StudyCalendar",
        },
        {
          label: "在线客服",
          imgSrc: require("@/assets/images/index/index-kinds-service.png"),
          path: "OnlineService",
        },
      ],
      messageCount: "",
    };
  },
  methods: {
    getIndex() {
      let param = {
        classify_id:
          this.$store.state.personInfo.classify_id || localStorage.classify_id,
      };
      this.$http.get(`/api/app/recommend/appIndex`, param).then((res) => {
        this.recommend = res;
      });
    },
    getBaner() {
      this.$http.get(`/api/app/banner`).then((res) => {
        this.bannerList = res;
      });
    },
    toTeach(id) {
      this.$router.push({
        name: "Teacher",
        query: {
          id: id,
        },
      });
    },
    toMore(item) {
      let name = "ShowTeachers";
      if (item.channel_info.type == 1 || item.channel_info.type == 2) {
        name = "Course";
      } else if (item.channel_info.type == 5) {
        name = "News";
      } else if (item.channel_info.type == 6) {
        name = "BookList";
      } else if (item.channel_info.type == 7) {
        //章节练习
        name = "Exercise";
      } else if (item.channel_info.type == 8) {
        //模拟考试
        name = "Exam";
      }
      this.$router.push({
        name: name,
      });
    },
    async bannerClick(item) {
      /**
       * link_type  1 自定义链接  2课程  3资讯 4图书 5章节练习 6模拟考试
       */
      let link_type_arr = [
        "",
        "",
        "CourseDetail",
        "NewsDetail",
        "BookDetail",
        "ExerciseDetail",
        "ExamDetail",
      ];
      let query = { id: item.link_content };
      if (item.link_type == 1) {
        window.location.href = item.link_content;
      } else if (item.link_type > 1) {
        if (item.course_type == 4) {
          //banner中的公开课直接进入直播间
          let info = await this.$http.get(
            `/api/app/getPcRoomCode/course_id=${item.course_id}/chapter_id=0`
          );
          if (!localStorage.adminToken) {
            //未登录
            let timestamp = new Date().getTime();
            localStorage.setItem("start_time", timestamp);
          }
          this.$router.push({
            name: "PublicCoursePlay",
            query: { src: info.chapterInfo.web_url },
          });
        } else {
          if (item.link_type == 6) {
            query.type = "Exam";
          }
          this.$router.push({
            name: link_type_arr[item.link_type],
            query: query,
          });
        }
      }
    },
    goFunction(name) {
      this.$router.push({
        name,
      });
    },
    setClassify() {
      this.$store.commit("SET_CLASSIFY", true);
    },
    getMessageCount() {
      this.$http.get(`/api/app/messageStatus`).then((res) => {
        this.messageCount = res.count;
        if (this.messageCount > 99) {
          this.messageCount = this.messageCount + "+";
        }
      });
    },
  },
  created() {
    this.getBaner();
    this.getIndex();
    if (localStorage.adminToken) {
      //已登录
      this.getMessageCount();
    }
  },
};
</script>
<style lang="scss" scoped>
.index-page {
  background: #ffffff;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 100px;
  overflow: hidden;
  .index-search {
    height: 100px;
    display: flex;
    align-items: center;
    .message {
      width: 70px;
      height: 44px;
      margin-right: 20px;
      background: url("~@/assets/images/message_icon.png") no-repeat left center;
      background-size: 44px 44px;
      position: relative;
      i {
        display: inline-block;
        top: -6px;
        right: -9px;
        font-size: 10px;
        color: #fff;
        position: absolute;
        background-color: #e62e2a;
        text-align: center;
        border-radius: 50%;
        height: 18px;
        min-width: 11px;
        border-radius: 16px;
        padding: 4px 8px !important;
        font-size: xx-small;
        transform: scale(0.8);
        vertical-align: middle;
        line-height: 18px !important;
      }
    }
    .classify {
      font-size: 30px;
      margin-left: 20px;
      color: #333333;
      width: 220px;
      span {
        width: 120px;
        display: inline-block;
        padding: 6px 0;
        @include eps;
      }
      img {
        width: 10px;
      }
    }
    .search {
      margin: 0 26px;
      width: 100%;
      height: 60px;
      border-radius: 33px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background: #f7f7f7;
      padding: 0 30px;
      box-sizing: border-box;
      span {
        font-size: 30px;
        font-family: PingFangSC;
        font-weight: 400;
        color: #bfbfbf;
        margin-left: 20px;
      }
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .index-banner {
    margin: 30px 29px;
    position: relative;
    // background: linear-gradient(#0146fd, #33daf3);
    .van-swipe {
      height: 280px;
      overflow: hidden;
      border-radius: 30px;
      border: 1px solid #fff;
    }
    .banner {
      height: 324px;
      height: 100%;
      position: relative;
      background-position: center center;
      background-size: cover;
      .images {
        width: 100%;
        height: 100%;
      }
      img {
        border-radius: 30px;
        width: 100%;
        height: 100%;
      }
    }
  }
  .index-kinds {
    margin: 41px 0;
    position: relative;
    font-family: PingFangSC-Regular;
    ul {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        @extend %flex-center;
        flex-direction: column;
        background: #fff;
        border-radius: 20px;
        width: 120px;
        height: 156px;
        margin: 0 14px 20px 7px;
        img {
          width: 89px;
          height: 89px;
          display: block;
        }
        font {
          margin-top: 30px;
          font-size: 24px;
          font-weight: 400;
          color: rgba(140, 140, 140, 1);
        }
      }
    }
  }
  .no-banner {
    margin-top: 20px;
  }
  .op-title {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(89, 89, 89, 1);
    position: relative;
    padding-left: 54px;
    line-height: 40px;
    height: 40px;
    font-size: 32px;
    &::after {
      position: absolute;
      content: "";
      left: 30px;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 32px;
      background: $theme_color;
    }
    .more {
      float: right;
      color: #bebebe;
      font-size: 22px;
      margin-right: 30px;
      height: 32px;
      line-height: 32px;
      /deep/ {
        i {
          vertical-align: middle;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
